module.exports = __webpack_public_path__ + "static/media/congo-republic-of-the-flag-xl.4455ea2b.png";